import { useFormik } from "formik";
import { Col, Modal, Row } from "react-bootstrap";
import { Button } from "../common/Button";
import TextInput from "../common/textfield/TextInput";
import { useState } from "react";
import * as Yup from 'yup';
import moment from "moment";
import { useSelector } from "react-redux";
import { addManualReadingForPatient } from "../api/VitalObservation";
import { failed, success } from "../common/Toastify";

const BloodGlucoseModal = ({ bloodGlucoseModalShow, bloodGlucoseModalClose, units, programId }) => {
    const storedProfile = sessionStorage.getItem("relatedPersonProfile");
    const storedId = storedProfile ? JSON.parse(storedProfile).id : null;

    const patientId = useSelector((state) => storedId || state?.auth?.user?.["custom:unique_id"]);

    //const patientId = useSelector((state) => state?.auth?.user?.["custom:unique_id"]);
    const [btnLoading, setBtnLoading] = useState(false);
    const currentDate = moment(new Date()).format('MM/DD/YYYY');


    const formik = useFormik({
        initialValues: {
            glucose: ""
        },
        validationSchema: Yup.object({
            glucose: Yup.number()
                .typeError("Must be a number")
                .min(0, "Must be greater than or equal to 0")
                .max(999, "Must be less than or equal to 999")
                .test(
                    "decimal-places",
                    "Only two decimal places are allowed",
                    value => (value + "").match(/^\d+(\.\d{1,2})?$/)
                )
                .required("Glucose is required"),
        }),
        onSubmit: (values) => {
            setBtnLoading(true);
            let params = {
                patientId: patientId,
                programId: programId,
                effectiveDateTime: currentDate,
                conditionName: "blood_glucose",
                valueQuantity: {
                    value: {
                        glucose: values.glucose
                    },
                    unit: {
                        glucose: units.glucose
                    },
                },
                device: {
                    reference: 'Device/null',
                }
            };

            addManualReadingForPatient(params)
                .then((res) => success(res?.message))
                .catch((error) => failed(error))
                .finally(() => {
                    setBtnLoading(false);
                    bloodGlucoseModalClose();
                })
        }
    })

    return (
        <Modal
            backdropClassName
            backdrop={'static'}
            show={bloodGlucoseModalShow} onHide={bloodGlucoseModalClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered className="custom-dialog">

            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter">Blood Glucose Reading</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                    <Row>
                        <Col>
                            <TextInput keyField={"glucose"} formik={formik} label={`Glucose (${units.glucose})`} placeholder={"Enter here..."} readOnly={false} disabled={false} required={true} />
                        </Col>
                    </Row>

                    <div className="btn-wrap">
                        <Button
                            onClick={() => {
                                bloodGlucoseModalClose();
                            }}
                            variant="secondary"
                            title="Cancel"
                        >
                            Cancel
                        </Button>
                        <Button type="submit" isLoading={btnLoading}>
                            Add
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
};

export default BloodGlucoseModal;